"use client"
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import { Box, IconButton, Typography, Chip, useTheme, alpha, Paper, useMediaQuery, Tooltip } from "@mui/material"
import PaidIcon from "@mui/icons-material/Paid"
import InventoryIcon from "@mui/icons-material/Inventory"
import EqualizerIcon from '@mui/icons-material/Equalizer'
import PersonIcon from "@mui/icons-material/Person"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import ScheduleIcon from "@mui/icons-material/Schedule"
const CustomPagination = ({ currentPage, totalPages, totalCount, montoTotalTransacciones, vieneDe, montoFinalCaja = 0, mostrarMontoFinal = true, totalIngresos = 0, totalEgresos = 0, sumaMontosSeleccionados, cantidadSeleccionados, onPageChange }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"))
  const isMobileOrTablet = isMobile || isTablet
  const esTablaGastos = vieneDe === "tablaGastos"

  // Determinar el icono y texto según el contexto
  const getContextInfo = () => {
    if (vieneDe === "tablaVentas" || vieneDe === "tablaCompras" || vieneDe === "tablaDetalle" || vieneDe == "tablaCaja") {
      return {
        icon: <PaidIcon fontSize="small" sx={{ color: "#4CAF50" }} />,
        label: `$${montoTotalTransacciones?.toLocaleString("es-AR") || "0.00"}`,
        color: "#4CAF50",
        vieneDe: vieneDe == 'tablaVentas' ? "tablaVentas" : null,
      }
    } else if (vieneDe === "inventaryComponent") {
      return {
        icon: <InventoryIcon fontSize="small" color="primary" />,
        label: `${totalCount} registros`,
        color: theme.palette.primary.main,
      }
    } else if (vieneDe === "tablaEntidades") {
      return {
        icon: <PersonIcon fontSize="small" sx={{ color: "#5b5b5f" }} />,
        label: `${totalCount} entidades`,
        color: "#5b5b5f",
      }
    } else if (vieneDe === "tablaRrhhEmpleados") {
      return {
        icon: <PersonIcon fontSize="small" sx={{ color: "#5b5b5f" }} />,
        label: `${totalCount} empleados`,
        color: "#5b5b5f",
      }
    } else if (vieneDe === "tablaRrhhTurnos") {
      return {
        icon: <ScheduleIcon fontSize="small" sx={{ color: "#5b5b5f" }} />,
        label: `${totalCount} turnos`,
        color: "#5b5b5f",
      }
    } else if (vieneDe === "tablaRrhhFichajes") {
      return {
        icon: <ScheduleIcon fontSize="small" sx={{ color: "#5b5b5f" }} />,
        label: `${totalCount} fichajes`,
        color: "#5b5b5f",
      }
    } else if (vieneDe === "tablaRrhhAsistencia") {
      return {
        icon: <ReceiptLongIcon fontSize="small" sx={{ color: "#5b5b5f" }} />,
        label: `${totalCount} asistencias`,
        color: "#5b5b5f",
      }
    }
    return null
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
    }).format(amount || 0)
  }

  const getTipoTextoCantidad = () => {
    if (vieneDe === "tablaVentas") {
      return "#Registros "
    } else if (vieneDe === "inventaryComponent") {
      return ""
    } else if (vieneDe === "tablaEntidades") {
      return ""
    } else if (vieneDe === "tablaRrhhEmpleados") {
      return ""
    } else if (vieneDe === "tablaRrhhTurnos") {
      return ""
    } else if (vieneDe === "tablaRrhhFichajes") {
      return ""
    } else if (vieneDe === "tablaRrhhAsistencia") {
      return ""
    } else {
      return "#Registros "
    }
  }

  const contextInfo = getContextInfo()
  const textoCantidad = getTipoTextoCantidad()

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: vieneDe === "tablaCaja" && !isMobileOrTablet ? "space-between" : isMobileOrTablet ? "center" : "space-between",
        backgroundColor: alpha(theme.palette.background.paper, 0.95),
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        padding: isMobileOrTablet ? "8px 4px" : "0px",
        flexDirection: isMobileOrTablet ? "column" : "row",
        gap: isMobileOrTablet ? 1 : 0,
        position: "sticky",
        bottom: 0,
        zIndex: 100,
        boxShadow: isMobileOrTablet ? "0px -2px 8px rgba(0,0,0,0.1)" : "none",
        width: "100%",
      }}
    >
      <Box 
        sx={{ 
          display: "flex", 
          gap: 1, 
          my: isMobileOrTablet ? 0 : 1, 
          justifyContent: isMobileOrTablet ? "center" : "flex-end", 
          alignItems: "center",
          flexWrap: "wrap",
          width: isMobileOrTablet ? "100%" : "auto",
          order: isMobileOrTablet ? 2 : 1,
        }}
      >
        {vieneDe != 'inventaryComponent' ? (
          <Chip
            icon={<EqualizerIcon fontSize={isMobileOrTablet ? "small" : "small"} />}
            label={
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "black",
                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                }}
              >
                {textoCantidad} {totalCount}
              </Typography>
            }
            variant="outlined"
            size={isMobileOrTablet ? "small" : "medium"}
            sx={{
              borderColor: "rgb(1,1,1,0.5)",
            }}
          />
        ) : null}

        {(vieneDe == 'inventaryComponent' || vieneDe == 'tablaVentas' || vieneDe == 'tablaDetalle' || vieneDe == 'tablaCompras' || vieneDe == 'tablaEntidades' || vieneDe == 'tablaRrhhEmpleados' || vieneDe == 'tablaRrhhTurnos' || vieneDe == 'tablaRrhhFichajes' || vieneDe == 'tablaRrhhAsistencia') && contextInfo ? (
          <Chip
            icon={contextInfo.icon}
            label={
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: contextInfo.color,
                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                }}
              >
                {contextInfo.label}
              </Typography>
            }
            variant="outlined"
            size={isMobileOrTablet ? "small" : "medium"}
            sx={{
              borderColor: alpha(contextInfo.color, 0.5),
              backgroundColor: alpha(contextInfo.color, 0.05),
              marginLeft: isMobileOrTablet ? 0 : (contextInfo.vieneDe == 'tablaVentas' ? '340px' : '140px'),
            }}
          />
        ) : null}

      </Box>

      {esTablaGastos && (
        <Box sx={{ 
          display: "flex", 
          gap: 1.5, 
          justifyContent: "center", 
          alignItems: "center", 
          flex: 1,
          order: isMobileOrTablet ? 3 : 2,
          my: isMobileOrTablet ? 0 : 1,
        }}>
          <Paper
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: alpha("#F44336", 0.1),
              border: `2px solid ${alpha("#F44336", 0.3)}`,
              minWidth: 170,
              textAlign: "center",
              boxShadow: "0px 2px 8px rgba(244, 67, 54, 0.2)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#F44336" }}>
                Gasto total
              </Typography>
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#F44336" }}>
              {formatCurrency(montoTotalTransacciones)}
            </Typography>
          </Paper>
        </Box>
      )}

      {(vieneDe == 'tablaCaja') ? (
          <Box 
            sx={{ 
              display: "flex", 
              gap: 1, 
              justifyContent: isMobileOrTablet ? "center" : "center",
              alignItems: "center",
              width: isMobileOrTablet ? "100%" : "auto",
              order: isMobileOrTablet ? 3 : 2,
              my: isMobileOrTablet ? 0 : 1,
              flexWrap: "wrap",
            }}
          >
            {/* ✅ NUEVO: Ingreso Total */}
            <Tooltip title="Total de todas las páginas" arrow>
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: "#4CAF50",
                  color: "white",
                  minWidth: isMobileOrTablet ? 140 : 180,
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.3)",
                  cursor: "help",
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                  Ingreso Total:
                </Typography>
                <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                  {formatCurrency(totalIngresos)}
                </Typography>
              </Paper>
            </Tooltip>

            {/* ✅ NUEVO: Egreso Total */}
            <Tooltip title="Total de todas las páginas" arrow>
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: "#f44336",
                  color: "white",
                  minWidth: isMobileOrTablet ? 140 : 180,
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(244, 67, 54, 0.3)",
                  cursor: "help",
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                  Egreso Total:
                </Typography>
                <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                  {formatCurrency(totalEgresos)}
                </Typography>
              </Paper>
            </Tooltip>

            {/* ✅ ACTUALIZADO: Monto Neto (ahora usa totales globales) */}
            <Tooltip title="Total de todas las páginas" arrow>
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: "#5b5b5f",
                  color: "white",
                  minWidth: isMobileOrTablet ? 140 : 180,
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(244, 177, 14, 0.3)",
                  cursor: "help",
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                  Monto Neto:
                </Typography>
                <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                  {contextInfo.label}
                </Typography>
              </Paper>
            </Tooltip>
            
            {/* ✅ ACTUALIZADO: Monto Final (ahora usa totales globales) - PROTEGIDO POR PERMISOS */}
            {mostrarMontoFinal && (
              <Tooltip title="Total de todas las páginas" arrow>
                <Paper
                  sx={{
                    p: 1,
                    borderRadius: 2,
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    minWidth: isMobileOrTablet ? 140 : 180,
                    textAlign: "center",
                    boxShadow: "0px 4px 12px rgba(244, 177, 14, 0.3)",
                    cursor: "help",
                    transition: "transform 0.2s",
                    "&:hover": {
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                    Monto Final:
                  </Typography>
                  <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                    {formatCurrency(montoFinalCaja)}
                  </Typography>
                </Paper>
              </Tooltip>
            )}

          </Box>

        ) : null}

      {/* Controles de paginación */}
      <Box 
        sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: isMobileOrTablet ? 0.5 : 1,
          justifyContent: isMobileOrTablet ? "center" : "flex-end",
          width: isMobileOrTablet ? "100%" : "auto",
          order: isMobileOrTablet ? 1 : esTablaGastos ? 3 : 2,
        }}
      >
        {sumaMontosSeleccionados != null && sumaMontosSeleccionados > 0 ? (
          <Chip
            icon={<ReceiptLongIcon fontSize="small" sx={{ color: "rgb(244, 147, 14)" }} />}
            label={
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "rgb(244, 147, 14)",
                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                }}
              >
                A facturar: ${(sumaMontosSeleccionados || 0).toLocaleString("es-AR")}
              </Typography>
            }
            variant="outlined"
            size={isMobileOrTablet ? "small" : "medium"}
            sx={{
              borderColor: "rgba(244, 147, 14, 0.5)",
              backgroundColor: "rgba(244, 147, 14, 0.08)",
              marginRight: isMobileOrTablet ? 0 : 1,
            }}
          />
        ) : null}
        <IconButton
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          size={isMobileOrTablet ? "small" : "small"}
          sx={{
            color: currentPage === 1 ? "text.disabled" : "primary.main",
            backgroundColor:
              currentPage === 1
                ? "transparent"
                : alpha(theme.palette.primary.main, 0.1),
            "&:hover": {
              backgroundColor:
                currentPage === 1
                  ? "transparent"
                  : alpha(theme.palette.primary.main, 0.2),
            },
            padding: isMobileOrTablet ? "4px" : "8px",
          }}
        >
          <ArrowBackIosNewIcon fontSize={isMobileOrTablet ? "small" : "small"} />
        </IconButton>

        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 500,
            fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
            px: isMobileOrTablet ? 0.5 : 1,
            textAlign: "center",
            minWidth: isMobileOrTablet ? "80px" : "auto",
          }}
        >
          {isMobileOrTablet ? `${currentPage}/${totalPages}` : `Página ${currentPage} de ${totalPages}`}
        </Typography>

        <IconButton
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          size={isMobileOrTablet ? "small" : "small"}
          sx={{
            color:
              currentPage === totalPages ? "text.disabled" : "primary.main",
            backgroundColor:
              currentPage === totalPages
                ? "transparent"
                : alpha(theme.palette.primary.main, 0.1),
            "&:hover": {
              backgroundColor:
                currentPage === totalPages
                  ? "transparent"
                  : alpha(theme.palette.primary.main, 0.2),
            },
            padding: isMobileOrTablet ? "4px" : "8px",
          }}
        >
          <ArrowForwardIosIcon fontSize={isMobileOrTablet ? "small" : "small"} />
        </IconButton>
      </Box>
    </Box>
  );
}

export default CustomPagination
